<template>
    <div>
        <b-row>
            <b-col cols="12" md="6">
                <app-form-select
                    :options="venues"
                    label="Sedes"
                    v-model="serviceSpot.venueId"
                    :has-error="$v.serviceSpot.venueId.$error"
                    error-message="Debe diligenciar el campo"
                    value-field="id"
                    text-field="name"
                ></app-form-select>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-select
                    label="Tipo"
                    :options="serviceSpotTypes"
                    @change="$v.serviceSpot.serviceSpotTypeId.$touch()"
                    :has-error="$v.serviceSpot.serviceSpotTypeId.$error"
                    error-message="Debe diligenciar el campo"
                    v-model="serviceSpot.serviceSpotTypeId"
                    value-field="id"
                    text-field="name"
                ></app-form-select>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    label="Nombre"
                    v-model="serviceSpot.name"
                    @input="$v.serviceSpot.name.$touch()"
                    :has-error="$v.serviceSpot.name.$error"
                    error-message="Debe diligencia el campo"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    label="Teléfono"
                    v-model="serviceSpot.phone"
                ></app-form-text-input>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import serviceSpotRepository from '@repositories/serviceSpot.repository';
// import FormSelect from '@components/UI/Controls/Forms/FormSelect';
export default {
    components: {
        // appFormSelect: FormSelect
    },
    props: {
        theClient: {
            type: Object,
            required: true
        },
        venues: {
            type: Array,
            default: () => []
        },
        serviceSpotTypes: {
            type: Array,
            default: () => []
        },
        item: {
            type: [Object, String],
            default: () => null
        }
    },
    data: () => ({
        serviceSpot: {
            venueId: '',
            serviceSpotTypeId: '',
            name: '',
            phone: ''
        }
    }),
    validations: {
        serviceSpot: {
            venueId: { required },
            serviceSpotTypeId: { required },
            name: { required },
        }
    },
    methods: {
        initialize() {
            !!this.item && this.fillForm();
        },
        fillForm() {
            this.serviceSpot.venueId = this.item.venue_id;
            this.serviceSpot.serviceSpotTypeId = this.item.structure_type_id;
            this.serviceSpot.name = this.item.name;
            this.serviceSpot.phone = this.item.phone;
        },
        async save() {
            const payload = {...this.serviceSpot, clientId: this.theClient.id};
            !!this.item && (payload.id = this.item.id);

            const sr = {...serviceSpotRepository};

            try {
                const { data } = !this.item
                    ? await sr.save(payload)
                    : await sr.update(payload, this.item.id);

                this.reset();
                this.$emit('saved', data);
            } catch(err) {
                this.handleErrors(err);
            }

            
        },
        reset() {
            Object.keys(this.serviceSpot).map(key => this.serviceSpot[key] = '');
            this.$v.$reset();
        },
        initialize() {
            if(!!this.item) {
                this.fillForm();
            }
        }
    },
    created() {
        this.$bus.$on('service-spot-form.save', this.save);
        this.initialize();
    },
    beforeDestroy() {
        this.$bus.$off('service-spot-form.save');
    }
}
</script>